import React from "react"

import { Container, CardBody, Card } from "reactstrap"

import Breadcrumb from "components/Common/Breadcrumb"
import AllSingleItems from "../Single Item Master"

const AllAddressType = () => {

    document.title = "Address Type Master | Peacock Accountants Limited";

    return (
        <div>
            <div className="page-content mb-5">
                <Container fluid >
                    <Breadcrumb
                        title={"Dashboard"}
                        breadcrumbItem={"Address Type Master"}
                    />

                    <Card className="px-0 mx-0">
                        <CardBody >
                            <AllSingleItems
                                api_name={"address-type"}
                                heading={"address type"}
                                title={"Address Type"}
                                fieldName={"addressType"}
                                module_id={7}
                            />
                        </CardBody>
                    </Card>

                </Container>
            </div>
        </div>
    )
}

export default AllAddressType
